import React from "react";
import './SearchBox.css';

const SearchBox = ({ searchChange }) =>{
    return(
        <div className="pa2">
            <input 
            className="pa3 ba b--green bg-lightest-blue" 
            type='search' 
            placeholder='Search robots'
            onChange={searchChange} //note that the onChange event listener was used here to call searchChange function
            />
        </div>
    );
}

export default SearchBox